import Route from '@ember/routing/route';

export default class AppServicesWaldenBoxRoute extends Route {}
